import { useSelector } from 'react-redux';

import DefaultMessage from './DefaultMessage';
import NotSearchResult from './NotSearchResult';
import './index.scss';

import { coordinateData } from '../../../../store/location';

const NotResultList = () => {
    const { latitude, longitude } = useSelector(coordinateData);

    if (!latitude || !longitude) {
        return <DefaultMessage />;
    }

    return <NotSearchResult />;
};

export default NotResultList;
